export default {
    updateFolders(state, payload) {
        state.Folders = payload;
    },

    updateInfoUpload(state, payload) {
        state.InfoUpload = payload
    }
}